import { lazy } from 'react'

import { Loadable } from 'components'

import CommonLayout from 'layout/CommonLayout'
import AuthGuard from 'utils/route-guard/AuthGuard'

const Invitation = Loadable(lazy(() => import('pages/invitation')))

// ==============================|| AUTH ROUTING ||============================== //

const InvitationRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <CommonLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: '/invitation',
          element: <Invitation />,
        },
        {
          path: '/invitation/:id',
          element: <Invitation />,
        },
        {
          path: '*',
          element: <Invitation />,
        },
      ],
    },
  ],
}

export default InvitationRoutes
